import {actions} from './actions';
import {mutations} from './mutations';
import {getters} from './getters';
import {Module} from 'vuex';
import {RootState} from '@/store';
import {FeatureFlag} from "@/models/response/BrainpowerApiResponse";

export interface ConfigState{
    featureFlags: FeatureFlag
}

const initialState: ConfigState = {
    featureFlags: {} as FeatureFlag,
}

export const config: Module<ConfigState, RootState> = {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations
};
